import React, { useState, useEffect } from 'react';
import Toast from './Toast';

const GlobalToast = () => {
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  useEffect(() => {
    const handleToast = (event) => {
      const { message, type } = event.detail;
      setToast({ show: true, message, type });
    };

    window.addEventListener('showToast', handleToast);
    return () => window.removeEventListener('showToast', handleToast);
  }, []);

  return (
    <Toast
      show={toast.show}
      onClose={() => setToast({ ...toast, show: false })}
      message={toast.message}
      type={toast.type}
    />
  );
};

export default GlobalToast;
